import * as yup from 'yup';

const schema = yup.object().shape({
  width: yup.number().label('Width').required(),
  height: yup.number().label('Height').required(),
});

export default schema;
